import React from 'react';

import { Button } from '@components/Button';
import { Layout } from '@components/Layout';
import { makeMuiStyles, useCommonStyles } from '@styles';
import { createStrings } from '@utils/local';
import { url } from '@utils/pages';
import { Link, useLocation } from 'react-router-dom';

const strings = createStrings({
  ja: {
    noMatch: (p: string) => (
      <>
        お探しのページ「
        <span style={{ color: '#00647D' }}>{p}</span>
        」はありません。
      </>
    ),
    return: 'ホームへ',
  },
});

const useStyles = makeMuiStyles((theme, common) => ({
  container: {
    ...common.flexColumnCenter,
    ...common.biggerText,
    flex: 1,
    rowGap: '1rem',
  },
}));

export const NoMatch: React.FC = () => {
  const classes = {
    ...useCommonStyles(),
    ...useStyles(),
  };

  const location = useLocation();

  return (
    <Layout title="エラー">
      <div className={classes.container}>
        <div>{strings.noMatch(location.pathname)}</div>

        {import.meta.env.DEV && '[DEV] Did you run "yarn dev" again after you add a new page?'}

        <div>
          <Link to={url('/utilities/Dashboard')}>
            <Button text={strings.return} color="primary" shape="round" />
          </Link>
        </div>
      </div>
    </Layout>
  );
};
